import { useViewerMaybe } from "@/authentication/ViewerProvider"
import { Button } from "@/components/ui/button"
import { useLogout } from "@/util/useLogout"
import React from "react"
import AppleStoreImage from "../assets/images/apple-store-icon.svg"
import GooglePlayImage from "../assets/images/google-play-icon.svg"
import LogOutImage from "../assets/images/logout.svg"

const AppleStoreIcon = () => (
  <img
    src={AppleStoreImage}
    alt="Apple Store Logo"
    className="inline pr-1 pb-1"
    width={21}
    height={25}
  />
)
const GooglePlayIcon = () => (
  <img
    src={GooglePlayImage}
    alt="Google Play Logo"
    className="inline pr-1 pb-1"
    width={21}
    height={25}
  />
)

const AppleStoreDownloadLink = () => {
  return (
    <a href={window.novus.appleAppUrl} className="pl-6 font-normal">
      <AppleStoreIcon /> Apple
    </a>
  )
}

const GooglePlayDownloadLink = () => {
  return (
    <a href={window.novus.googlePlayAppUrl} className="pl-6 font-normal">
      <GooglePlayIcon /> Google Play
    </a>
  )
}

export const Header = () => {
  const { viewer } = useViewerMaybe()
  const logout = useLogout()
  return (
    <header>
      <nav className="p-2 border-b text-center font-semibold flex items-center justify-between">
        <div className="w-[110px]" />
        <div>
          Download our FREE app! Available on iOS & Android.
          <AppleStoreDownloadLink />
          <GooglePlayDownloadLink />
        </div>
        <div className="w-[110px] text-right flex-shrink-0">
          {!!viewer && (
            <Button
              onClick={() => {
                logout()
              }}
              size="sm"
              variant="outline"
            >
              <div className="flex items-center gap-1">
                <img src={LogOutImage} alt="Log Out" />
                Log Out
              </div>
            </Button>
          )}
        </div>
      </nav>
    </header>
  )
}
